<template>
  <div class="my-4 align-self-center login-second-step">
      <div v-if="!phoneHint">
          <b-form @submit="submit" id="form-submit-phone-user">
            <p class="mb-4">Registre seu número para recebimento de token via SMS.</p>
            <b-form-group label-for="phone">
                <b-form-input id="phone" placeholder="(99) 99999-9999" :state="phoneState" v-model="form.phone" v-mask="['(##) #####-####']" trim />
                <b-form-invalid-feedback :state="phoneState">{{validation.phone}}</b-form-invalid-feedback>
            </b-form-group>
          <div class="d-flex justify-content-end">
            <b-button pill @click="cancelar" class="btn-base outline-primary-btn mr-2">Voltar</b-button> 
            <b-button pill type="submit" class="btn-base primary-btn">Enviar</b-button>      
          </div>
        </b-form>
      </div>

      <div v-else>
        <b-form @submit="submit" id="form-login-second-step">
          <div v-if="isTokenExpired">
              <p class="hint mb-2">Seu token expirou. Clique no botão para reenviar o token via SMS para {{ phoneHint }}.</p>
              <div class="d-flex justify-content-end mt-2">
                <b-button pill type="submit" class="btn-base outline-primary-btn mr-2">Voltar</b-button> 
                <b-button pill type="submit" class="btn-base primary-btn">Reenviar</b-button>
              </div>
          </div>
          <div v-else>
              <p class="hint mb-2"> Informe o token enviado para o número {{ phoneHint }}.</p>
              <b-form-group label-for="Token">
                  <b-form-input id="token__" placeholder="Digite aqui o token enviado por SMS" :state="tokenState" v-model="form.token" maxlength="6" trim />
                  <b-form-invalid-feedback :state="tokenState">{{validation.token}}</b-form-invalid-feedback>
              </b-form-group>
              <div class="d-flex justify-content-end mt-2">
                <b-button pill @click="cancelar" class="btn-base outline-primary-btn mr-2">Voltar</b-button> 
                <b-button pill type="submit" class="btn-base primary-btn">Entrar ({{countFormatedState}})</b-button>      
              </div>
          </div>
        </b-form>
        <br/>
      </div>
      
      <b-badge class="mb-3 mt-4" :variant="validation.variant" v-if="validation.msg" style="white-space: break-spaces;">
          {{ validation.msg }}
      </b-badge>

      <div class="d-flex justify-content-end mt-2">
        <p class="btn-auth-type" @click="changeTypeAuth()">Tentar de outra maneira</p>
      </div>

  </div>
</template>

<script>
import Validations from "@/util/Validations"
import LoginResource from "@/resources/LoginResource"
import UserResource from "@/resources/UserResource"
import LoginUtils from '@/util/LoginUtils'
import { replaceNotNumbers } from "@/util/utils"
import { mapGetters } from "vuex"
import { SMS } from "@/util/utils"

export default {
  data() {
    return {
      form: {
        token: null,
        reliableDevice: false,
        shippingType : 2,
        phone: null,
        startKeyUp: null
      },
      validation: {
        token: null,
        phone: null
      },
      timer: null,
      phoneHint: null,
      count: 60,
      looper: null,
      endCooldownTimeResendToken: null,
    }
  },
  computed: {
    ...mapGetters("user", ["jwt"]),
    tokenState() {
      return this.validation.token ? false : null
    },
    phoneState()
    {
      return this.validation.phone ? false : null
    },
    countFormatedState() {
      return this.count
    },
    isTokenExpired() {
      return this.count <= 0
    },
    phone() {
      return this.phoneHint || this.form.phone
    }
  },
  methods: {
    startCount() {

      clearInterval(this.looper); 

      this.updateCount();
      
      this.looper = setInterval(() => {
        this.updateCount();

        if (this.count <= 0) {
          clearInterval(this.looper);
        }
      }, 1000);
    },
    updateCount() {
      if (!this.endCooldownTimeResendToken) {
        this.count = 0
        return
      }

      let differenceInMillis = this.endCooldownTimeResendToken.getTime() - new Date().getTime();
      
      this.count = Math.round(differenceInMillis / 1000);
    },
    resendToken() {
      this.sendToken(this.form.phone);
    },
    sendToken (phone) {
      if(phone) {
        phone = replaceNotNumbers(phone);
      }

      LoginResource.sendToken(this.form.shippingType, phone, {context: "login", showLoader: true})
      .then( (response) => {
        this.endCooldownTimeResendToken = new Date(new Date().getTime() + response.durationTokenInMilli)
        this.form.token = null
      })
    },
    submit (event) {
      event.preventDefault();

      if (!this.phoneHint) {
        this.submitPhone()
        this.startKeyUp = false
        return
      }

      if (this.isTokenExpired) {
        this.sendToken()
        this.startKeyUp = false
        return
      } 
      
      this.submitLogin()
    },
    submitPhone() {

      this.validation = {
        token: null,
        phone: null
      }

      this.validation.phone = !this.form.phone ? "Este campo é obrigatório!" : null

      this.validation.phone = Validations.cellPhone(this.form.phone, false, true)
      
      if (!Validations.isEmpty(this.validation)) {
        return
      }

      this.phoneHint = this.form.phone

      this.sendToken(this.form.phone)

    },
    handleKeyupEnter(event) {

      if(!this.startKeyUp) {
        this.startKeyUp = true
        return;
      }

      if (event.key === 'Enter' && (this.phone || this.startKeyUp)) {
        this.submit(event);
      }

    },
    changeTypeAuth() {
        this.$emit("change-auth-type", SMS )
    },
    submitLogin() {

      this.validation = {}

      this.validation.token = !this.form.token ? "Este campo é obrigatório!" : null

      if (!Validations.isEmpty(this.validation)) {
        return
      }

      LoginResource.loginSecondStep(this.form.token, this.form.reliableDevice, {context: "login", showLoader: true, showValidationAlert: true})
      .then(response => {
        this.$emit("save-auth-tokens", response)
      })
    },
    cancelar() {
      this.$emit("clear-logged-user")
    }
  },
  created() {
    UserResource.getPhoneHint(this.jwt.user_name, { showLoader: true})
    .then((hint) => {
      if (!hint || !hint.end) {
        return
      }
      this.phoneHint = `(${hint.start}) XXXXX-${hint.end}`
      this.sendToken()
    })

    this.timer = setInterval(() => {
      if (!LoginUtils.isInSecondStep()) {
        this.$emit("clear-logged-user")
      }
    }, 1000)
  },
  mounted() {
    document.addEventListener('keyup', this.handleKeyupEnter);
  },
  beforeDestroy() {
    clearInterval(this.timer)
    clearInterval(this.looper)
    document.removeEventListener('keyup', this.handleKeyupEnter);
  },
  watch: {
    endCooldownTimeResendToken() {
      this.startCount()
    }
  }
}
</script>

<style>
.button-bar {
  width: 77%;
  display: flex;
  justify-content: space-between;
}

.login-second-step .button-bar {
  text-align: right;
}

.login-second-step .hint {
  width: 100%;
}

.reliable-device {
	width: 100%;
	height: 50px;
	display: flex;
	align-items: flex-end;
	justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 40px;
}

.reliable-device label {
  color: #707070 !important;
	font-size: 16px !important;
}

.select-token {
  text-align: left !important;
}
</style>